<!--计费名称 priceConfiguration1-->
<template>
  <div class="myhistoryValue">
    <div class="con">
      <div class="right-table">
        <div class="Files-top">
          <div class="ic-left" @click="getList2">
            <span>计费名称</span>
          </div>
          <div class="btns">
            <el-button @click="add_ed" type="primary" class="last-el-button">新增</el-button>
          </div>
        </div>
        <div class="search-input-btn" style="width:100%">
          <div class="input-small">
            <span>单位名称：</span>
            <el-input v-model="listData.unitName" clearable placeholder="请输入单位名称"></el-input>
          </div>
          <el-button type="primary" plain @click="getList" class="search-btn">查询</el-button>
        </div>
        <div class="mytable" id="region-cost">
          <el-table :data="dataList" :height="heights" border style="width: 100%;">
            <el-table-column label="序号" width="90" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="unitName" label="单位名称" />
            <el-table-column prop="name" label="计费名称" />
            <el-table-column prop="year" label="年" />
            <el-table-column prop="month" label="月" />
            <el-table-column prop="deductionStandard" label="当前单价" />
          </el-table>
          <span class="paginationed">
            <Pagination align="center" :total="total" :page.sync="listData.pageNum" :page-sizes="[5, 10, 15, 20, total]"
              :limit.sync="listData.pageSize" @pagination="getList" />
          </span>
        </div>
      </div>
      <!-- 新增修改 -->
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
        center width="700px">
        <div class="mydialog">
          <el-form :model="temp" :rules="rules" ref="temp" label-width="150px">
            <el-form-item label="单位名称:" prop="unitName">
              <el-input v-model="temp.unitName"></el-input>
            </el-form-item>
            <el-form-item label="计费名称:" prop="name">
              <el-input v-model="temp.name"></el-input>
            </el-form-item>
            <el-form-item label="年月:" prop="month">
              <el-date-picker v-model="temp.month" type="month" placeholder="选择月" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="当前单价:" prop="deductionStandard">
              <el-input v-model="temp.deductionStandard"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

    </div>
  </div>
</template>

<script type="text/javascript">
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  import Pagination from "@/components/module/Pagination"; // 分页
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {
      elUnitTree,
      downloadTable,
      elIconBtn,
      Pagination
    },
    data () {
      return {
        listData: {
          unitId: this.$store.unitStore.getters.getNowUnit.id,
          pageNum: 1,
          pageSize: 10,
          unitName: ''
        },
        total: 10,
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()<Date.now();
          },
        },
        dialogVisible3: false,
        dataList2: [],
        dialogVisible2: false,
        temp: {},
        dialogStatus: '',
        dialogVisible: false,
        heights: document.getElementById('app').clientHeight-290,
        dataList: [],
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        rules: {
          unitName: [
            {required: true,message: '请输入单位名称',trigger: 'blur'}
          ],
          name: [
            {required: true,message: '请输入计费名称',trigger: 'blur'}
          ],
          month: [
            {required: true,message: '请选择年月',trigger: 'change'}
          ],
          deductionStandard: [
            {required: true,message: '请输入当前单价',trigger: 'blur'}
          ],
        },
        temped: {},
      }
    },
    watch: {
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      },
    },
    mounted () {
      // this.$store.unitStore.getters.getNowUnit.id
      this.getList();
    },

    methods: {
      submit () {

        var params=this.temp;
        console.log(params);
        request({url: "/meterReading/saveMeterBillingModeJY.do",method: "get",params}).then(res => {
          if(res.success) {
            this.dialogVisible3=false;
            this.getList();
          }
        })
      },
      getList2 () {
        var params={activeName: 'first'}
        request({url: "/meterReading/findAllMeterBillingModeJY.do",method: "get",params}).then(res => {
          if(res.success) {
            this.dataList=res.data.StepBilling;
          }
        })
      },
      getList (v) {
        var params=this.listData;
        request({url: "/meterBill/findMeterBillModeRecordList",method: "get",params}).then(res => {
          if(res.code==200) {
            this.dataList=res.data.content;
            this.total=res.data.totalElements;
          }
        })
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {

            var data={
              unitId: this.$store.unitStore.getters.getNowUnit.id,
              unitName: this.temp.unitName,
              name: this.temp.name,
              year: this.temp.month.getFullYear(),
              month: this.temp.month.getMonth()+1,
              deductionStandard: this.temp.deductionStandard,
            }

            request({url: "/meterBill/save",method: "post",data}).then(data => {
              console.log(data,'data');
              if(data.code==200) {
                this.temp={}
                this.dialogVisible=false;
                this.dialogVisible2=true;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
                this.getList()
                var params={pkId: this.temped.pkid};
                request({url: "/meterBill/findMeterBillModeRecord",method: "get",params}).then(res => {
                  if(res.code==200) {
                    this.dataList2=res.data;
                    this.dialogVisible2=true;
                  }
                })
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed2 () {
        this.dialogVisible3=true;
        // console.log(v);
        this.temp={
          'unitId': this.$store.unitStore.getters.getNowUnit.id
        }
      },
      // 添加弹窗
      add_ed () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        // console.log(v);
        this.temp={
          'pkId': this.temped.pkid,
        }
        console.log(this.temp,'111');
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.temp.pkId=this.temped.pkid;
            var data=this.temp;

            request({url: "/meterBill/save",method: "post",data}).then(data => {
              console.log(data,'data');
              if(data.code==200) {
                this.temp={}
                this.dialogVisible=false;
                this.dialogVisible2=true;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
                this.getList()
                var params={pkId: this.temped.pkid};
                request({url: "/meterBill/findMeterBillModeRecord",method: "get",params}).then(res => {
                  if(res.code==200) {
                    this.dataList2=res.data;
                    this.dialogVisible2=true;
                  }
                })
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }
            })

          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        console.log(v,'vvv');
        this.temp={
          'pkId': v.pkid,
          "id": v.id,
          "deductionStandard": v['单价'],
          "year": v['年'],
          "month": v['月'],
          "state": 1,
          "defaultType": 1,
          "name": v['计费名称'],
        }
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },


    }
  }
</script>

<style scoped lang="scss">
  .paginationed {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }

  .mytable {
    margin-top: 15px;
  }

  .myhistoryValue {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // 正常
      .patrol {
        p {
          width: 8px;
          height: 8px;
          background-color: #0DAE88;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #0DAE88;
        }
      }

      // 非正常
      .rush {
        p {
          width: 8px;
          height: 8px;
          background-color: #FF1D1D;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FF1D1D;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .tree-left {
        width: 300px;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: 100%;
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>